import { lazy } from 'react';

const Guidelines = lazy(() => import('./Guidelines'));

export default Guidelines;
